(function () {
  'use strict';

  var PRESS_SELECTOR = [
    '.kcs-search__submit',
    '.kcs-header .header__icon--account',
    '.kcs-header .header__icon--cart',
    '.kcs-header .header__inline-menu a',
    '.kcs-header .header__inline-menu summary',
    '.kcs-header .header__heading-link',
    '.kh__btn',
    '.kh__arrow',
    '.kh__dot'
  ].join(',');

  function replayClass(element, className, duration) {
    if (!element) return;
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
    window.setTimeout(function () {
      element.classList.remove(className);
    }, duration || 360);
  }

  function bindGlobalPressAnimation() {
    if (document.documentElement.dataset.kcsPressReady === '1') return;
    document.documentElement.dataset.kcsPressReady = '1';

    document.addEventListener('pointerdown', function (event) {
      var target = event.target.closest(PRESS_SELECTOR);
      if (!target) return;
      replayClass(target, 'kcs-tap', 360);
    });
  }

  function initSearch(form) {
    if (!form || form.dataset.kcsReady === '1') return;
    form.dataset.kcsReady = '1';

    form.addEventListener('submit', function () {
      replayClass(form, 'is-submitting', 520);
    });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-kcs-search]').forEach(initSearch);
    bindGlobalPressAnimation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
